<template>

</template>

<script>
import { mapState } from 'vuex';

export default {
  name: "LoginWithToken",
  async created () {
    if (await this.$store.dispatch(`loginWithToken`, this.$route.params.token)) {
      await this.$store.dispatch(`fetchMe`);
      return window.location.href = this.me.homeUrl;
    }
    window.location.href = `/`;
  },
  computed: {
    ...mapState([
        `me`,
    ]),
  },
};
</script>

<style scoped>

</style>
